

import { module } from 'modujs';
import { loadImage } from '../utils/image';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.loadImages();
    }

    loadImages() {
        const images = Array.from(this.el.querySelectorAll('img'))

        if(images) {
            const promises = images.map(img => {
                return loadImage(img.src)
            })

            Promise.all(promises).then(() => {
                this.call('update', null, 'Scroll');
            })
        }
    }

    destroy() {
        super.destroy();
    }
}
